import { render, staticRenderFns } from "./CriticalInputMaterials.vue?vue&type=template&id=2392882e&scoped=true&"
import script from "./CriticalInputMaterials.vue?vue&type=script&lang=js&"
export * from "./CriticalInputMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392882e",
  null
  
)

export default component.exports